import { render, staticRenderFns } from "./ReportsHistory.vue?vue&type=template&id=0662ff17"
import script from "./ReportsHistory.vue?vue&type=script&lang=js"
export * from "./ReportsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports